module.exports = __webpack_public_path__ + "img/WorkplaceIcon.4048f818.svg";